// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__guYTS","col":"Table_col__1VeFA","fulfillmentStatus":"Table_fulfillmentStatus__3n7l_","emailCol":"Table_emailCol__1N5EJ"};